/** @module Quality/SupplierReviewForm */
define([
    "dojo/_base/declare",
    "Operations/ReviewForm"
], function(declare,ReviewForm) {

    return declare(ReviewForm, {

        ownerNodeType : "Supplier"

    });
 });

